import { render, staticRenderFns } from "./applicants-list.vue?vue&type=template&id=6369255d&scoped=true"
import script from "./applicants-list.vue?vue&type=script&lang=js"
export * from "./applicants-list.vue?vue&type=script&lang=js"
import style0 from "./applicants-list.vue?vue&type=style&index=0&id=6369255d&prod&scoped=true&lang=css"
import style1 from "./applicants-list.vue?vue&type=style&index=1&id=6369255d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6369255d",
  null
  
)

export default component.exports